function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "llx5dmz31a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#D8D8D8"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "url(#llx5dmz31a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 6.095l2 1.678V13c0 1.054.816 1.918 1.85 1.995L6 15h6c.182 0 .358-.024.526-.07l1.68 1.408c-.633.418-1.39.662-2.206.662H6c-2.21 0-4-1.79-4-4V6.095zm.552-3.452l14.554 12.213c.424.355.479.986.124 1.409-.355.423-.986.478-1.41.123L1.267 4.175c-.423-.355-.478-.986-.123-1.409.355-.423.986-.478 1.409-.123zM9 1c1.864 0 3.43 1.275 3.874 3H14c1.105 0 2 .895 2 2v6.621l-2-1.678V6h-1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L11 6H8.109L5.25 3.602C5.818 2.082 7.282 1 9 1zm0 2c-.74 0-1.387.402-1.733 1h3.465C10.387 3.402 9.74 3 9 3z"
})));

function SvgShoppingBagDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagDisabled);
export default __webpack_public_path__ + "static/media/shopping-bag-disabled.8a0986cd.svg";
export { ForwardRef as ReactComponent };